import { Avatar, AvatarGroup, Tooltip } from '@chakra-ui/react'
import React from 'react'
import { useMessageProperties } from '../message-provider'

export default function MessagePatient() {
    const { message } = useMessageProperties()

    const patients =
        message.patients?.length > 0
            ? message.patients
            : message.patient
              ? [message.patient]
              : []

    if (!patients.length) return null

    const names = patients.map(p => p.name || 'Unknown').join(', ')

    return (
        <Tooltip
            label={`Assigned to ${names}`}
            hasArrow
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
            rounded="lg"
        >
            <AvatarGroup size="xs" max={4} spacing="-6px">
                {patients.map(patient => (
                    <Avatar
                        key={patient.id}
                        name={patient.name || 'Unknown'}
                        w="18px"
                        h="18px"
                        fontSize="13px"
                    />
                ))}
            </AvatarGroup>
        </Tooltip>
    )
}
